import { RouteAwareCrumbs } from 'Components/shared/breadcrumbs';
import { Header as BalanceShow } from 'Components/header/Header';
import Text from 'Components/shared/text'
import React from 'react'

import styles from '../wallet.module.css'

const Header = ({currency}) => {
    const NameMap = {
        naira:{
            "/wallet/naira":"Naira Wallet",
            "/wallet": "Wallet"
        },
        dollar:{
            "/wallet/dollar":"Dollar Wallet",
            "/wallet": "Wallet"
        },
        euro:{
            "/wallet/euro":"Euro Wallet",
            "/wallet": "Wallet"
        }
       
    }
    const headers = {
        naira:"Naira Wallet",
        dollar:"Dollar Wallet",
        euro:"Euro Wallet"
    }
    return (
        <div className={styles.Header}>
            <div className='w-full space-between row-start'>
                <div>
                    <Text variant="lg" tag="h1" style={{fontWeight:"700"}}>{headers[currency]}</Text>
                    <RouteAwareCrumbs nameMap={NameMap[currency]} />
                </div>
                <BalanceShow hidden />
            </div>
        </div>
        )
}

export default Header